// WARNING: DO NOT EDIT. This file is automatically generated.

const awsConfig = {
    "region": "eu-west-1",
    "stage": "spex-7023",
    "accountName": "development",
    "api_url": "https://73bhp6pd79.execute-api.eu-west-1.amazonaws.com/spex-7023/graphql",
    "notifications_api_url": "https://73bhp6pd79.execute-api.eu-west-1.amazonaws.com/spex-7023/notifications",
    "run_daily_test_url": "https://sadroeq8df.execute-api.eu-west-1.amazonaws.com/test/run-daily-test",
    "sport_highlights_url": "https://lgt6u5isozhh5g6u2mr2suzcni.appsync-api.eu-west-1.amazonaws.com/graphql",
    "appconfig_url": "https://73bhp6pd79.execute-api.eu-west-1.amazonaws.com/spex-7023/getConfig",
    "direct_appconfig_url": "https://r365vowf6ngmxnnrthbo3spcxe.appsync-api.eu-west-1.amazonaws.com/graphql",
		"endpoint_url" : "https://73bhp6pd79.execute-api.eu-west-1.amazonaws.com/spex-7023",
    "mgmt_ui_appconfig_dropdown_profile": "mgmt-ui-dropdown-options",
    "mgmt_ui_appconfig_configs_profile": "mgmt-ui-configs",
    "daily-test-game-configs": "daily-testing-configs",
    "leagues": "leagues",
    "aws_project_region": "eu-west-1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_gGQE2q0Yv",
    "aws_user_pools_web_client_id": "2m2q9iiednc64co51n016on383",
    "oauth": {
        "domain": "spex-mgmt-ui-hosting-spex-7023.auth.eu-west-1.amazoncognito.com",
        "scope": [
          "phone",
          "email",
          "profile",
          "openid",
          "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://mgmt.spex-7023.spex-dev.aidisco.sky.com",
        "redirectSignOut": "https://mgmt.spex-7023.spex-dev.aidisco.sky.com",
        "responseType": "code"
    },
    "bitmovinLicenseKey": "2c2acb4c-6bb3-4087-98d2-0d5ecc0a6258",
    "defaultChannelName": "ExternalSLE",
    "licenseAcquisitionEndpointUrl": "",
    "arcusLicenseAcquisitionEndpointUrl": ""
};

export default awsConfig;

